// assets
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import ProductOutlined from '@ant-design/icons/ProductOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import ShopOutlined from '@ant-design/icons/ShopOutlined';
import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import SwapOutlined from '@ant-design/icons/SwapOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined';
import TruckOutlined from '@ant-design/icons/TruckOutlined';

// icons
const icons = {
  ProductOutlined,
  ProfileOutlined,
  TruckOutlined,
  DatabaseOutlined,
  ToolOutlined,
  ShoppingCartOutlined,
  SwapOutlined,
  TeamOutlined,
  SafetyCertificateOutlined,
  ShopOutlined
};

const modules = {
  id: 'group-modules',
  title: 'modules',
  type: 'group',
  children: [
    {
      id: 'equipment',
      title: 'equipment',
      type: 'collapse',
      icon: icons.ProductOutlined,
      permissions: ['equipment.create', 'equipment.read-all'],
      children: [
        {
          id: 'equipment-create',
          title: 'equipment-create',
          type: 'item',
          url: '/apps/equipment/create',
          breadcrumbs: false,
          permissions: ['equipment.create']
        },
        {
          id: 'equipment-list',
          title: 'equipment-list',
          type: 'item',
          url: '/apps/equipment/list',
          breadcrumbs: false,
          permissions: ['equipment.read-all']
        }
      ]
    },
    {
      id: 'inventory',
      title: 'inventory',
      type: 'collapse',
      icon: icons.DatabaseOutlined,
      permissions: ['warehouse.read-all', 'order.read-all'],
      children: [
        {
          id: 'inventory-list',
          title: 'inventory-list',
          type: 'item',
          url: '/apps/warehouse/list',
          breadcrumbs: false,
          permissions: ['warehouse.read-all']
        }
      ]
    },
    {
      id: 'warehouse',
      title: 'warehouse',
      type: 'collapse',
      icon: icons.ShopOutlined,
      permissions: ['warehouse.read-admin', 'warehouse.modify'],
      children: [
        {
          id: 'warehouse-list',
          title: 'warehouse-list',
          type: 'item',
          url: '/apps/warehouse/admin-list',
          breadcrumbs: false,
          permissions: ['warehouse.read-admin']
        }
      ]
    },
    {
      id: 'equipment-order',
      title: 'equipment-order',
      type: 'collapse',
      icon: icons.ProfileOutlined,
      permissions: ['order.create', 'order.read-all'],
      children: [
        {
          id: 'order-create',
          title: 'create-equipment-order',
          type: 'item',
          url: '/apps/equipment-order/create',
          breadcrumbs: false,
          permissions: ['order.create']
        },
        {
          id: 'order-list',
          title: 'equipment-order-list',
          type: 'item',
          url: '/apps/equipment-order/list',
          breadcrumbs: false,
          permissions: ['order.read-all']
        }
      ]
    },
    {
      id: 'movement',
      title: 'movement',
      type: 'collapse',
      icon: icons.TruckOutlined,
      permissions: ['own-movement.create', 'own-movement.read-all'],
      children: [
        {
          id: 'own-movement-create',
          title: 'create-own-movement',
          type: 'item',
          url: '/apps/own-movement/create',
          breadcrumbs: false,
          permissions: ['own-movement.create']
        },
        {
          id: 'own-movement-list',
          title: 'own-movement-list',
          type: 'item',
          url: '/apps/own-movement/list',
          breadcrumbs: false,
          permissions: ['own-movement.read-all']
        }
      ]
    },
    {
      id: 'service',
      title: 'service',
      type: 'collapse',
      icon: icons.ToolOutlined,
      permissions: ['service-order.create', 'service-order.read-all'],
      children: [
        {
          id: 'service-order-create',
          title: 'create-service-order',
          type: 'item',
          url: '/apps/service-order/create',
          breadcrumbs: false,
          permissions: ['service-order.create']
        },
        {
          id: 'service-order-list',
          title: 'service-order-list',
          type: 'item',
          url: '/apps/service-order/list',
          breadcrumbs: false,
          permissions: ['service-order.read-all']
        }
      ]
    },
    {
      id: 'purchase',
      title: 'purchase',
      type: 'collapse',
      icon: icons.ShoppingCartOutlined,
      permissions: ['purchase.create', 'purchase.read-all'],
      children: [
        {
          id: 'create-equipment-purchase',
          title: 'create-equipment-purchase',
          type: 'item',
          url: '/apps/equipment-purchase/create',
          breadcrumbs: false,
          permissions: ['purchase.create']
        },
        {
          id: 'equipment-purchase-list',
          title: 'equipment-purchase-list',
          type: 'item',
          url: '/apps/equipment-purchase/list',
          breadcrumbs: false,
          permissions: ['purchase.read-all']
        }
      ]
    },
    {
      id: 'inventory-adjustment',
      title: 'inventory-adjustment',
      type: 'collapse',
      icon: icons.SwapOutlined,
      permissions: ['inventory-adjustment.create', 'inventory-adjustment.read-all'],
      children: [
        {
          id: 'create-inventory-adjustment',
          title: 'create-inventory-adjustment',
          type: 'item',
          url: '/apps/inventory-adjustment/create',
          breadcrumbs: false,
          permissions: ['inventory-adjustment.create']
        },
        {
          id: 'inventory-adjustment-list',
          title: 'inventory-adjustment-list',
          type: 'item',
          url: '/apps/inventory-adjustment/list',
          breadcrumbs: false,
          permissions: ['inventory-adjustment.read-all']
        }
      ]
    },
    {
      id: 'users',
      title: 'users',
      type: 'collapse',
      icon: icons.TeamOutlined,
      permissions: ['user.create', 'user.read-all'],
      children: [
        {
          id: 'user-list',
          title: 'user-list',
          type: 'item',
          url: '/apps/user/list',
          breadcrumbs: false,
          permissions: ['user.read-all']
        }
      ]
    },
    {
      id: 'role',
      title: 'role-permission',
      type: 'collapse',
      icon: icons.SafetyCertificateOutlined,
      permissions: ['role.create', 'role.read-all', 'permission.read-all'],
      children: [
        {
          id: 'permission-list',
          title: 'permission-list',
          type: 'item',
          url: '/apps/permission/list',
          breadcrumbs: false,
          permissions: ['permission.read-all']
        },
        {
          id: 'role-list',
          title: 'role-list',
          type: 'item',
          url: '/apps/role/list',
          breadcrumbs: false,
          permissions: ['role.read-all']
        }
      ]
    }
  ]
};

export default modules;
